import axios from "axios";
import constants from "../../utils/constants";

const API_URL = constants.FIXOR;

const save = (client, instance, request) => {
    return axios.post(`${API_URL}bymaOR/newOrderSingle?client=${client}&instance=${instance}`, request);
};

const getOrders = (client, instance) => {
    return axios.get(`${API_URL}bymaOR/findAll?client=${client}&instance=${instance}`);
};

const getOrderById = (client, instance, id) => {
    return axios.get(`${API_URL}bymaOR/findById?client=${client}&instance=${instance}&id=${id}`);
};

const orderCancel = (client, instance, request) => {
    return axios.post(`${API_URL}bymaOR/orderCancel?client=${client}&instance=${instance}`, request);
};

const cancelReplace = (client, instance, request) => {
    return axios.post(`${API_URL}bymaOR/cancelReplace?client=${client}&instance=${instance}`, request);
};

const orderSingle = {
    save,
    getOrders,
    getOrderById,
    orderCancel,
    cancelReplace
}

export default orderSingle;
